
import { V4UUID } from '@/firebase/database';
import { uploadWsAsTemplate } from '@/firebase/templateDb';
import { useGlobalStore } from '@/modules/globalModule/store';
import { defineComponent, PropType } from 'vue';
import { useControlCenterStore } from '../store';
export default defineComponent({
  name: 'UploadTemplatePopup',
  props: {
    visible: { type: Boolean, required: true },
    exit: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  data(): {
    id: V4UUID;
    name: string;
    image: string;
    resText: string;
  } {
    return { id: '', name: '', image: '', resText: '' };
  },
  methods: {
    uploadWorkspace() {
      const globalStore = useGlobalStore();
      const ccStore = useControlCenterStore();
      if (this.id !== '')
        uploadWsAsTemplate(
          this.name,
          globalStore.packages,
          ccStore.previousConnections[0],
          ccStore.launchFiles,
          this.image !== '' ? this.image : undefined,
          this.id
        )?.then(() => {
          this.setResText(this.name, this.id);
        });
      else
        uploadWsAsTemplate(
          this.name,
          globalStore.packages,
          ccStore.previousConnections[0],
          ccStore.launchFiles,
          this.image !== '' ? this.image : undefined
        )?.then(() => {
          this.setResText(this.name);
        });
    },
    uploadImage(event: any) {
      if (
        !event.target ||
        !event.target.files ||
        event.target.files.length === 0
      )
        return;
      const image = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e: any) => {
        this.image = e.target.result;
      };
    },
    setResText(name: string, id: string = '') {
      this.resText = `Template ${name} with id ${id} has been successfully uploaded`;
    }
  }
});
